import React from "react"
import { AutoFixHigh } from "@mui/icons-material"
import { CircularProgress, Fab, Tooltip } from "@mui/material"

interface GenerateWithAIFabProps {
  onClick: () => unknown | Promise<unknown>
  disabled: boolean
  loading: boolean
  tooltip: string
  label?: string
}

const GenerateWithAIFab: React.FC<GenerateWithAIFabProps> = ({
  onClick,
  disabled,
  loading,
  tooltip,
  label = "Generate With AI"
}) => {
  return (
    <Tooltip title={tooltip}>
      <span>
        <Fab
          variant="extended"
          color="primary"
          onClick={onClick}
          disabled={disabled}
          sx={{ position: "fixed", right: 24, bottom: 24, zIndex: theme => theme.zIndex.fab }}>
          {loading ? <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} /> : <AutoFixHigh sx={{ mr: 1 }} />}
          {label}
        </Fab>
      </span>
    </Tooltip>
  )
}

export default GenerateWithAIFab
